import { render, staticRenderFns } from "./DetailIntro.vue?vue&type=template&id=4d86a660&scoped=true"
import script from "./DetailIntro.vue?vue&type=script&lang=js"
export * from "./DetailIntro.vue?vue&type=script&lang=js"
import style0 from "./DetailIntro.vue?vue&type=style&index=0&id=4d86a660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86a660",
  null
  
)

export default component.exports